package com.appsyde.shared.modules.auth.data

import com.appsyde.shared.modules.auth.domain.model.DomainError
import com.appsyde.shared.network.exception.InsufficientScopesException
import com.appsyde.shared.network.exception.NotAuthenticatedException
import com.appsyde.shared.network.exception.RemoteApiException

/**
 * Maps network/auth exceptions to domain errors. Extracted for unit testing.
 * Used by [AuthRepositoryImpl].
 */
internal fun mapExceptionToDomainError(e: Throwable): DomainError = when (e) {
    is NotAuthenticatedException -> DomainError.NotAuthenticated
    is InsufficientScopesException -> DomainError.InsufficientScopes
    is RemoteApiException -> DomainError.Api(code = e.code, requestId = e.requestId, message = e.message)
    else -> DomainError.Unknown(e.message)
}
